{
  "alert": {
    "ccm_fields": ["action", "alert_type", "message", "severity", "title"],
    "keywords": ["alert"],
    "name": "Alert",
    "sourcetypes": ["bro:notice:json", "bro_notice", "zscalernss-alerts"]
  },
  "cloud": {
    "ccm_fields": [
      "account_id",
      "account_name",
      "cloud_platform",
      "instance_id",
      "instance_name",
      "instance_type",
      "region",
      "user_agent",
      "src_ip",
      "username",
      "identity_principal_id",
      "group_id",
      "user_type",
      "event_name",
      "process_cmdline",
      "bytes_in",
      "bytes_out",
      "account_id",
      "authentication_method",
      "error_code",
      "error_message",
      "event_id",
      "event_type",
      "hostname",
      "message",
      "dest_hostname",
      "storage_property_name",
      "storage_target_object",
      "user_access_id",
      "source_user_role",
      "user_role",
      "mfa_auth",
      "request_parameters"
    ],
    "keywords": ["aws", "azure", "cloud", "digitalocean", "gcp"],
    "name": "Cloud",
    "sourcetypes": ["digitalocean"]
  },
  "dns": {
    "ccm_fields": [
      "dest_ip",
      "dest_port",
      "dns_answer",
      "dns_query",
      "dns_record_type",
      "event_id",
      "hostname",
      "process_name",
      "process_path",
      "protocol",
      "query_name",
      "src_ip",
      "src_port"
    ],
    "keywords": ["bind", "dns"],
    "name": "DNS",
    "sourcetypes": [
      "MSAD:NT6:DNS",
      "aws:route53:dns",
      "bro:dns:json",
      "bro_dns",
      "corelight_dns",
      "infoblox:dns",
      "isc:bind:query",
      "zscalernss-dns"
    ]
  },
  "edr": {
    "ccm_fields": [
      "dest_ip",
      "dest_port",
      "dns_query",
      "domain",
      "event_id",
      "event_type",
      "file_name",
      "file_path",
      "hostname",
      "logon_process",
      "logon_type",
      "md5",
      "message",
      "object_loaded",
      "parent_process_cmdline",
      "parent_process_id",
      "parent_process_name",
      "parent_process_path",
      "pipe_name",
      "process_cmdline",
      "process_id",
      "process_name",
      "process_path",
      "registry_key_name",
      "registry_new_value_name",
      "registry_path",
      "registry_value_name",
      "service_file_path",
      "service_name",
      "sha256",
      "sid",
      "src_ip",
      "target_path",
      "url",
      "username"
    ],
    "keywords": ["carbonblack", "crowdstrike", "tanium"],
    "name": "Endpoint Detection & Response (EDR)",
    "sourcetypes": [
      "CrowdStrike:Event:Streams:JSON",
      "bit9:carbonblack:json",
      "carbonblack",
      "crowdstrike",
      "crowdstrike:alerts",
      "crowdstrike:falconhost:json",
      "grr_flow_result",
      "tanium:json"
    ]
  },
  "email": {
    "ccm_fields": [
      "dest_hostname",
      "email_recipient",
      "email_sender",
      "email_subject",
      "protocol",
      "src_hostname"
    ],
    "keywords": ["email", "mimecast", "msexchange", "smtp"],
    "name": "Email",
    "sourcetypes": [
      "bro:smtp:json",
      "bro_smtp",
      "bro_smtp_entities",
      "cisco:esa:cef",
      "cisco:esa:delivery",
      "mimecast",
      "pps_log",
      "pps_mail_log",
      "pps_messagelog"
    ]
  },
  "endpoint": {
    "ccm_fields": [
      "access",
      "accesses",
      "action",
      "application_name",
      "dest_domain",
      "dest_hostname",
      "dest_ip",
      "dest_port",
      "details",
      "event_id",
      "event_type",
      "file_name",
      "hostname",
      "logon_process",
      "logon_type",
      "message",
      "object_loaded",
      "object_name",
      "parent_process_cmdline",
      "parent_process_id",
      "parent_process_name",
      "parent_process_path",
      "pipe_name",
      "process_cmdline",
      "process_id",
      "process_name",
      "process_path",
      "protocol",
      "record_id",
      "registry_key_name",
      "registry_new_value_name",
      "registry_old_value_name",
      "registry_path",
      "registry_value_name",
      "service_file_path",
      "service_name",
      "sid",
      "src_hostname",
      "src_ip",
      "src_port",
      "target_path",
      "task_category",
      "username"
    ],
    "keywords": [],
    "name": "Endpoint",
    "sourcetypes": [
      "XmlWinEventLog:Microsoft-Windows-Sysmon/Operational",
      "sysmon",
      "sysmon:xml",
      "WinEventLog",
      "xmlwineventlog"
    ]
  },
  "endpoint:sysmon": {
    "ccm_fields": [
      "action",
      "dest_hostname",
      "dest_ip",
      "dest_port",
      "details",
      "dns_answer",
      "dns_query",
      "domain",
      "event_id",
      "event_type",
      "file_name",
      "file_path",
      "hostname",
      "logon_process",
      "logon_type",
      "md5",
      "message",
      "object_loaded",
      "parent_process_cmdline",
      "parent_process_id",
      "parent_process_name",
      "parent_process_path",
      "pipe_name",
      "process_cmdline",
      "process_id",
      "process_name",
      "process_path",
      "protocol",
      "record_id",
      "registry_key_name",
      "registry_new_value_name",
      "registry_old_value_name",
      "registry_path",
      "registry_value_name",
      "service_file_path",
      "service_name",
      "sha256",
      "sid",
      "src_hostname",
      "src_ip",
      "src_port",
      "target_path",
      "task_category",
      "url",
      "username"
    ],
    "keywords": ["sysmon"],
    "name": "Endpoint - Sysmon",
    "sourcetypes": [
      "XmlWinEventLog:Microsoft-Windows-Sysmon/Operational",
      "sysmon",
      "sysmon:xml"
    ]
  },
  "endpoint:wineventlog": {
    "ccm_fields": [
      "access",
      "accesses",
      "action",
      "application_name",
      "dest_domain",
      "dest_hostname",
      "dest_ip",
      "dest_port",
      "details",
      "dns_query",
      "event_id",
      "event_type",
      "file_name",
      "file_path",
      "hostname",
      "logon_process",
      "logon_type",
      "message",
      "object_loaded",
      "object_name",
      "parent_process_cmdline",
      "parent_process_id",
      "parent_process_name",
      "parent_process_path",
      "pipe_name",
      "process_cmdline",
      "process_id",
      "process_name",
      "process_path",
      "protocol",
      "record_id",
      "registry_key_name",
      "registry_new_value_name",
      "registry_old_value_name",
      "registry_path",
      "registry_value_name",
      "service_file_path",
      "service_name",
      "sid",
      "src_hostname",
      "src_ip",
      "src_port",
      "target_path",
      "task_category",
      "username"
    ],
    "keywords": ["wineventlog"],
    "name": "Endpoint - WinEventLog",
    "sourcetypes": ["WinEventLog", "xmlwineventlog"]
  },
  "http": {
    "ccm_fields": [
      "dest_ip",
      "dest_port",
      "dns_query",
      "domain",
      "hostname",
      "post_body",
      "process_name",
      "process_path",
      "query_name",
      "referrer",
      "request_method",
      "src_ip",
      "status_code",
      "uri",
      "url",
      "user_agent"
    ],
    "keywords": ["http"],
    "name": "HTTP",
    "sourcetypes": [
      "akamai:cm:json",
      "bluecoat:proxysg:access:syslog",
      "bro:http:json",
      "bro_http",
      "cisco:esa:http",
      "cisco:wsa:squid",
      "haproxy:http",
      "mcafee:wg:kv",
      "squid:access",
      "websense:cg:kv",
      "zscalernss-web"
    ]
  },
  "network": {
    "ccm_fields": [
      "bytes_in",
      "bytes_out",
      "dest_ip",
      "dest_mac",
      "dest_port",
      "dns_query",
      "dns_record_type",
      "domain",
      "event_id",
      "hostname",
      "message",
      "name",
      "process_id",
      "process_name",
      "process_path",
      "protocol",
      "query_name",
      "service",
      "src_ip",
      "src_mac",
      "src_port",
      "url"
    ],
    "keywords": ["firewall", "traffic"],
    "name": "Network Traffic",
    "sourcetypes": [
      "bro:conn:json",
      "bro_conn",
      "citrix:netscaler:ipfix:syslog",
      "citrix:netscaler:syslog",
      "corelight_conn",
      "juniper:junos:firewall",
      "juniper:junos:firewall:structured",
      "netscreen:firewall",
      "pan:traffic",
      "sophos:firewall",
      "sophos:utm:firewall",
      "symantec:ep:traffic:file",
      "zscalernss-fw"
    ]
  },
  "tls": {
    "ccm_fields": [
      "cipher_suite",
      "client_issuer",
      "client_subject",
      "dest_ip",
      "dest_port",
      "domain",
      "src_ip",
      "src_port"
    ],
    "keywords": ["ssl", "tls"],
    "name": "TLS",
    "sourcetypes": ["bro:ssl:json", "bro_ssl"]
  },
  "vpn": {
    "ccm_fields": [],
    "keywords": ["vpn"],
    "name": "VPN",
    "sourcetypes": ["pulse:connectsecure"]
  },
  "web": {
    "ccm_fields": [
      "dest_ip",
      "dest_port",
      "dns_query",
      "domain",
      "hostname",
      "process_name",
      "process_path",
      "query_name",
      "referrer",
      "request_method",
      "src_ip",
      "status_code",
      "uri",
      "url",
      "user_agent"
    ],
    "keywords": ["f5", "web"],
    "name": "Web",
    "sourcetypes": [
      "Imperva:Incapsula",
      "f5:bigip:apm:syslog",
      "f5:bigip:syslog",
      "pulse:connectsecure:web"
    ]
  },
  "xdr": {
    "ccm_fields": [
      "file_path",
      "hostname",
      "md5",
      "object_loaded",
      "parent_process_path",
      "process_cmdline",
      "process_id",
      "process_path",
      "sha256",
      "target_path",
      "username"
    ],
    "keywords": ["carbonblack", "crowdstrike", "tanium"],
    "name": "Extended Detection & Response (XDR)",
    "sourcetypes": [
      "CrowdStrike:Event:Streams:JSON",
      "bit9:carbonblack:json",
      "carbonblack",
      "crowdstrike",
      "crowdstrike:alerts",
      "crowdstrike:falconhost:json",
      "grr_flow_result",
      "tanium:json"
    ]
  }
}
